import { Alert, Button, Typography } from '@mui/material';
import LoadingSpinner from 'components/loading-spinner';
import { Box } from '@mui/material';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useInputSettingsState } from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/context/input-settings-context';

type Props = {
  children?: React.ReactNode;
  minHeight?: number;
};

const PAGE_ID = 'orderFeed.ofdMySupplyPlan';

const OfdSettingsFallback: React.FC<Props> = ({ children, minHeight = 220 }) => {
  const {
    getOfdSettingsQuery: { data: ofdSettings, isLoading: isOfdSettingsLoading, isFetching: isOfdSettingsFetching, isError: isOfdSettingsError, refetch },
  } = useInputSettingsState();

  const isInitialOfdSettingsLoading = (isOfdSettingsLoading || isOfdSettingsFetching) && !ofdSettings;
  const isOfdSettingsUnavailable = !isInitialOfdSettingsLoading && (isOfdSettingsError || !ofdSettings);

  if (isInitialOfdSettingsLoading) {
    return (
      <Box sx={{ borderRadius: 2, minHeight, display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
        <LoadingSpinner />
      </Box>
    );
  }

  if (!isOfdSettingsUnavailable) return <>{children ?? null}</>;

  return (
    <Alert
      severity="warning"
      action={
        <Button color="inherit" size="small" onClick={() => refetch()}>
          <FormattedMessage id={`${PAGE_ID}.retrySettingsFetch`} />
        </Button>
      }>
      <Typography variant="body1" fontWeight={700}>
        <FormattedMessage id={`${PAGE_ID}.settingsUnavailableTitle`} />
      </Typography>
      <Typography variant="body2">
        <FormattedMessage id={`${PAGE_ID}.settingsUnavailableMessage`} />
      </Typography>
    </Alert>
  );
};

export default OfdSettingsFallback;
